function escapeSvgText(text: string): string {
  if (!text) {
    return '';
  }

  return text
    .replace(/&/g, '&amp;') // Should be first to avoid double-escaping
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&apos;');
}

export type FallbackColor = 'white' | 'black';

type ColorHex = Record<FallbackColor, string>;

const COLOR_HEX: ColorHex = {
  white: '#ffffff',
  black: '#000000',
};
export const FALLBACK_BRAND_NAME = 'No brand logo';
export const DEFAULT_FALLBACK_COLOR: FallbackColor = 'black';
export const DEFAULT_FONT_SIZE = 26;

export function getSvgBrandLogo(
  brandName?: string | null,
  color: FallbackColor = DEFAULT_FALLBACK_COLOR,
  fontSize = DEFAULT_FONT_SIZE,
): string {
  if (!brandName) {
    brandName = FALLBACK_BRAND_NAME;
  }
  const colorHex = COLOR_HEX[color];
  const svgContent = `<svg width="220" height="150" viewBox="0 0 220 150" xmlns="http://www.w3.org/2000/svg">
            <rect width="220" height="150" fill="none"/>
            <text x="110" y="75" font-family="Open Sans, sans-serif" font-size="${encodeURIComponent(fontSize)}" font-weight="bold" text-anchor="middle" dominant-baseline="middle" fill="${escapeSvgText(colorHex)}">${escapeSvgText(brandName)}</text>
          </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svgContent)}`;
}
